import * as React from "react";
import { CalendarEvent } from "source/app/presentation/MainPanel/Calendar/CalendarEventUtils/CalendarEvent";
import { StyleClassAuto } from "source/app/presentation/Shared/Styles/Auto/StyleClassAuto";
import { EDragDropObject } from "source/app/services/Shared/EDragDropObject";
import { useDropTarget } from "source/app/services/Shared/Hooks/useDropTarget";
import { UpdateCalendarEventAsync } from "./Editor/UpdateCalendarEventAsync";
import { ICalendarEvent } from "motw_core/Calendar/ICalendarEvent";

export function CalendarEventDropTarget({
    calendarEvent,
}: {
    calendarEvent: CalendarEvent;
}) {
    const dropTargetResult = useDropTarget(
        [EDragDropObject.calendarEvent],
        (draggedObject: CalendarEvent) =>
            HandleDroppedCalendarEventAsync(draggedObject, calendarEvent)
    );

    if (!dropTargetResult.isDragging) {
        return null;
    }

    const isSourceEvent =
        calendarEvent.eventData.id ===
        dropTargetResult.draggedObject.eventData.id;

    if (isSourceEvent || calendarEvent.HasFinished) {
        return null;
    }

    const styleClass = StyleClassAuto({
        fontWeight: dropTargetResult.isOver ? `bold` : `inherit`,
        position: "absolute",
        left: "0",
        fontSize: "22px",
        width: "100%",
        background: "#121212",
        textAlign: "center",
        height: "40px",
        zIndex: 1,
        opacity: 0.7,
        borderRadius: `5px`,
    });

    const eventStartTime = CalendarEvent.FormatTime(
        calendarEvent.eventData.start
    );

    return (
        <span ref={dropTargetResult.dropTargetRef} className={styleClass}>
            {`move to ${eventStartTime}`}
        </span>
    );
}

async function HandleDroppedCalendarEventAsync(
    draggedObject: CalendarEvent,
    calendarEvent: CalendarEvent
) {
    const newStartTime = calendarEvent.eventData.start;
    const newEndTime = calendarEvent.eventData.end;

    const updatedCalendarEvent: ICalendarEvent = {
        ...draggedObject.eventData,
        start: newStartTime,
        end: newEndTime,
    };

    await UpdateCalendarEventAsync(updatedCalendarEvent);
}
